/** Split a route path that may include a hash fragment. */
export const splitRoutePath = path => {
  if (!path) return { pathname: path, hash: '' };
  const hashIndex = path.indexOf('#');
  if (hashIndex === -1) return { pathname: path, hash: '' };
  return {
    pathname: path.slice(0, hashIndex),
    hash: path.slice(hashIndex)
  };
};
